import Button from "../Reusable Elements/Button";
import SlideShow from "../Reusable Elements/SlideShow";
import { exceptionalHomesImages } from "../../data/slideShowData";

const ExceptionalHomes = () => {
    return (
        <div className="flex w-screen items-center justify-between sm:flex-row flex-col pt-7 sm:pb-7">
            <div className="flex flex-col sm:pl-10 sm:pr-14 sm:w-[60vw] px-2">
                <div
                    className="font-poppins font-extralight text-5xl sm:text-left text-center text-primary-blue"
                    style={{ lineHeight: "100%" }}
                >
                    Exceptional Homes
                </div>
                <div className="font-poppins text-xl font-extralight mt-5 sm:text-left text-center text-primary-blue sm:px-0 px-8">
                    With 40+ years of combined real estate development
                    expertise, we bring world-class quality to Pakistan.
                </div>
                <div className="font-poppins text-xl font-extralight mt-2 mb-8 sm:text-left text-center text-primary-blue sm:px-0 px-8">
                    Enjoy ultra-luxurious, smartly designed homes, blending
                    elegance and comfort for your ideal lifestyle.
                </div>
                <div className="flex sm:justify-start justify-center sm:pb-0 pb-7">
                    <Button
                        text={"Read More"}
                        color={"#ffffff"}
                        location={"/about"}
                    />
                </div>
            </div>
            <div>
                <SlideShow side={"right"} images={exceptionalHomesImages}/>
            </div>
        </div>
    );
};

export default ExceptionalHomes;
